import generateHash from './generateHash';

export interface EmailParts {
  greeting: string;
  message: string;
  currentUrl: string;
  pageType: string;
  pageSlug: string;
  giftAidMessage?: string;
  thanks: string;
}

export function generateEmailBody({
  greeting,
  message,
  currentUrl,
  pageType,
  pageSlug,
  giftAidMessage,
  thanks,
}: EmailParts) {
  const BR = '\n\n';
  const url = `${currentUrl}?utm_source=Sharethis&utm_medium=${pageType}&utm_content=${pageSlug}&utm_campaign=pfp-email&utm_term=${generateHash()}`;
  const giftAid = giftAidMessage ? `${giftAidMessage}${BR}` : '';
  return `${greeting}, ${BR}${message} ${url}${BR}${giftAid}${thanks}`;
}
